import api from "../base-url";
import { mutate } from "swr";

async function deleteApp(id: number) {
  try {
  let res = await api.delete(`/apps/${id}`);
  console.log("status", res.status);

  if(res.status >= 200 && res.status < 300) {
    mutate(`/apps`);
    console.log("ciao")
  } 
  return res.status;
} catch (error: any) {
  if (error.response) {
  console.log("error status", error.response.status)
  return error.response.status
  }
  }
}

export default deleteApp;
